import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const MikerryMerge = () => {
  const [stage, setStage] = useState('initial');

  useEffect(() => {
    const timer = setTimeout(() => setStage('merge'), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="mikerry-logo-container" style={{ fontSize: '3rem', fontWeight: 'bold', textAlign: 'center', height: '4rem' }}>
      <AnimatePresence mode="wait">
        {stage === 'merge' && (
          <motion.div
          key="merge"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 1 }}
          className="mikerry-merge-text"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem' }}
        >
          <motion.span
            initial={{ x: -150 }}
            animate={{ x: 49.9 }}
            transition={{ type: 'spring', stiffness: 10, damping: 10, duration: 4 }}
            className="mikerry-merge-text"
          >
            Mike
          </motion.span>

          <motion.span
              initial={{ scale: 1, opacity: 1 }}
              animate={{ scale: 0, opacity: 0 }}
              transition={{ delay: 1, duration: 2 }}
            >
              &
            </motion.span>

          <motion.span
            initial={{ x: 150 }}
            animate={{ x: -49.9 }}
            transition={{ type: 'spring', stiffness: 10, damping: 10, duration: 4 }}
            className="mikerry-merge-text"
          >
            kerry
          </motion.span>
          </motion.div>
        )}

      </AnimatePresence>
    </div>
  );
};

export default MikerryMerge;